import { FC, ReactNode } from 'react';

export const TableCard: FC<{ children: ReactNode }> = ({ children }) => {
  return <div className=" rounded-[10px] bg-base shadow-3xl">{children}</div>;
};
